import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/jp-morgan.css';

const Compliance = () => {
  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(180deg, #0a1628 0%, #050d18 100%)' }}>
      {/* Header */}
      <header className="border-b" style={{ borderColor: 'rgba(184, 134, 11, 0.1)', background: '#0a1628' }}>
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 rounded flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #b8860b 0%, #8b6914 100%)' }}>
              <span className="text-[#0a1628] font-bold text-lg">B</span>
            </div>
            <div>
              <h1 className="text-white text-lg font-light tracking-wide">BETHEREUM</h1>
              <p className="text-xs" style={{ color: '#6c757d', letterSpacing: '0.1em' }}>PRIVATE WEALTH MANAGEMENT</p>
            </div>
          </Link>
          <nav className="flex items-center gap-6">
            <Link to="/whitepaper" className="text-xs tracking-wider" style={{ color: '#6c757d' }}>WHITE PAPER</Link>
            <Link to="/terms" className="text-xs tracking-wider" style={{ color: '#6c757d' }}>TERMS</Link>
            <Link to="/privacy" className="text-xs tracking-wider" style={{ color: '#6c757d' }}>PRIVACY</Link>
            <Link to="/login" className="px-4 py-2 text-xs tracking-wider" style={{ color: '#b8860b', border: '1px solid rgba(184, 134, 11, 0.3)', borderRadius: '2px' }}>
              CLIENT LOGIN
            </Link>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-xs tracking-widest mb-6" style={{ color: '#b8860b' }}>
            REGULATORY FRAMEWORK
          </p>
          <h1 className="text-4xl md:text-5xl font-light text-white mb-6 tracking-wide">
            Compliance & Disclosures
          </h1>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto font-light">
            Important information regarding the use of BETH tokens and the Bethereum platform.
            Please read carefully before participating.
          </p>
        </div>
      </section>

      {/* Divider */}
      <div className="max-w-4xl mx-auto px-6">
        <div className="h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(184, 134, 11, 0.3), transparent)' }} />
      </div>

      {/* Important Risk Disclosures */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="p-8" style={{ background: 'rgba(245, 158, 11, 0.05)', border: '1px solid rgba(245, 158, 11, 0.2)', borderRadius: '2px' }}>
            <div className="flex items-start gap-4 mb-6">
              <div className="text-2xl">⚠️</div>
              <div>
                <h2 className="text-xl font-medium text-white mb-2">Important Risk Disclosures</h2>
                <p className="text-sm" style={{ color: '#6c757d' }}>Please review these disclosures carefully before using the platform.</p>
              </div>
            </div>
            
            <div className="space-y-6">
              <div className="p-4" style={{ background: 'rgba(0,0,0,0.2)', borderRadius: '2px' }}>
                <h3 className="text-sm font-medium tracking-wider mb-2" style={{ color: '#f59e0b' }}>USAGE AND VALUE RISK</h3>
                <p className="text-sm text-gray-300 leading-relaxed">
                  BETH tokens are digital assets intended for use within the Bethereum platform. Their value may fluctuate, 
                  and you may not be able to use or redeem them as intended.
                </p>
              </div>
              
              <div className="p-4" style={{ background: 'rgba(0,0,0,0.2)', borderRadius: '2px' }}>
                <h3 className="text-sm font-medium tracking-wider mb-2" style={{ color: '#f59e0b' }}>LIQUIDITY RISK</h3>
                <p className="text-sm text-gray-300 leading-relaxed">
                  BETH tokens are not transferable outside the platform. There may be no secondary market, and tokens 
                  may not be readily converted to cash or other assets.
                </p>
              </div>
              
              <div className="p-4" style={{ background: 'rgba(0,0,0,0.2)', borderRadius: '2px' }}>
                <h3 className="text-sm font-medium tracking-wider mb-2" style={{ color: '#f59e0b' }}>REGULATORY RISK</h3>
                <p className="text-sm text-gray-300 leading-relaxed">
                  Digital assets are subject to evolving laws and regulations. Changes in regulatory policies could 
                  affect the use, value, or accessibility of BETH tokens.
                </p>
              </div>
              
              <div className="p-4" style={{ background: 'rgba(0,0,0,0.2)', borderRadius: '2px' }}>
                <h3 className="text-sm font-medium tracking-wider mb-2" style={{ color: '#f59e0b' }}>NO GUARANTEE</h3>
                <p className="text-sm text-gray-300 leading-relaxed">
                  Bethereum and its affiliates make no guarantees regarding the value, return, or usability of BETH tokens. 
                  By using the platform, you accept that tokens carry inherent risk.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Legal Notices */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-xs tracking-widest mb-4" style={{ color: '#b8860b' }}>LEGAL FRAMEWORK</p>
            <h2 className="text-2xl font-light text-white">Legal Notices</h2>
          </div>

          <div className="space-y-6">
            <div className="p-6" style={{ background: '#1a2d4a', border: '1px solid rgba(184, 134, 11, 0.1)', borderRadius: '2px' }}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 rounded flex items-center justify-center" style={{ background: 'rgba(184, 134, 11, 0.2)' }}>
                  <span style={{ color: '#b8860b' }}>🔒</span>
                </div>
                <h3 className="text-white font-medium">Platform-Only Asset</h3>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed">
                BETH tokens are intended solely for use on the Bethereum platform. They are <strong className="text-white">not registered 
                securities</strong> under U.S. or state law and are not intended to be offered or sold as such. BETH tokens 
                represent utility within the platform ecosystem and do not convey ownership rights, profit participation, 
                or claims on any entity's revenues.
              </p>
            </div>

            <div className="p-6" style={{ background: '#1a2d4a', border: '1px solid rgba(184, 134, 11, 0.1)', borderRadius: '2px' }}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 rounded flex items-center justify-center" style={{ background: 'rgba(184, 134, 11, 0.2)' }}>
                  <span style={{ color: '#b8860b' }}>👤</span>
                </div>
                <h3 className="text-white font-medium">Accredited Investors Only</h3>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed">
                Access to BETH tokens and platform functionality is restricted to accredited investors in accordance 
                with platform policy. This restriction is implemented to ensure participants have the financial 
                sophistication and risk tolerance appropriate for engaging with digital asset infrastructure. 
                Verification is required prior to platform access.
              </p>
            </div>

            <div className="p-6" style={{ background: '#1a2d4a', border: '1px solid rgba(184, 134, 11, 0.1)', borderRadius: '2px' }}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 rounded flex items-center justify-center" style={{ background: 'rgba(184, 134, 11, 0.2)' }}>
                  <span style={{ color: '#b8860b' }}>📋</span>
                </div>
                <h3 className="text-white font-medium">Forward-Looking Statements</h3>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed">
                Any statements regarding potential benefits or future utility of BETH tokens are forward-looking 
                and involve risks and uncertainties. Actual results may differ materially from those expressed 
                or implied. No representation is made regarding the future value, utility, or availability of 
                BETH tokens or platform services.
              </p>
            </div>

            <div className="p-6" style={{ background: '#1a2d4a', border: '1px solid rgba(184, 134, 11, 0.1)', borderRadius: '2px' }}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 rounded flex items-center justify-center" style={{ background: 'rgba(184, 134, 11, 0.2)' }}>
                  <span style={{ color: '#b8860b' }}>⚖️</span>
                </div>
                <h3 className="text-white font-medium">Non-Investment Disclaimer</h3>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed">
                BETH tokens are not offered as an investment opportunity. The platform does not promise, guarantee, 
                or imply any return on the acquisition of BETH tokens. Users should not expect financial gains 
                from holding BETH tokens. The tokens are designed for utility purposes within the credit 
                enhancement and collateral infrastructure of the platform.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Platform Usage Section */}
      <section className="py-16 px-6" style={{ background: 'rgba(0,0,0,0.2)' }}>
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-xs tracking-widest mb-4" style={{ color: '#b8860b' }}>PLATFORM USAGE</p>
            <h2 className="text-2xl font-light text-white">BETH Token Utility</h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="p-6" style={{ background: '#1a2d4a', border: '1px solid rgba(184, 134, 11, 0.1)', borderRadius: '2px' }}>
              <h3 className="text-sm font-medium tracking-wider mb-4" style={{ color: '#b8860b' }}>PERMITTED USES</h3>
              <ul className="space-y-3">
                {[
                  'Collateral for credit enhancement',
                  'Internal settlement and accounting',
                  'Platform transaction facilitation',
                  'Participation in credit facilities'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-2 text-sm text-gray-300">
                    <span style={{ color: '#2e7d32' }}>✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="p-6" style={{ background: '#1a2d4a', border: '1px solid rgba(184, 134, 11, 0.1)', borderRadius: '2px' }}>
              <h3 className="text-sm font-medium tracking-wider mb-4" style={{ color: '#c62828' }}>PROHIBITED USES</h3>
              <ul className="space-y-3">
                {[
                  'Speculation or trading for profit',
                  'Investment or store of value',
                  'Transfer outside the platform',
                  'Resale to non-accredited parties'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-2 text-sm text-gray-300">
                    <span style={{ color: '#c62828' }}>✗</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Accredited Investor Criteria */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-xs tracking-widest mb-4" style={{ color: '#b8860b' }}>ACCESS REQUIREMENTS</p>
            <h2 className="text-2xl font-light text-white">Accredited Investor Qualifications</h2>
            <p className="text-sm text-gray-400 mt-4 max-w-2xl mx-auto">
              Platform access is limited to individuals and entities meeting the following criteria, 
              in accordance with SEC Rule 501 definitions used as a baseline for platform policy.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="p-6" style={{ background: '#1a2d4a', border: '1px solid rgba(184, 134, 11, 0.1)', borderRadius: '2px' }}>
              <h3 className="text-sm font-medium tracking-wider mb-4" style={{ color: '#b8860b' }}>INDIVIDUAL QUALIFICATIONS</h3>
              <ul className="space-y-3">
                {[
                  'Net worth exceeding $1,000,000 (excluding primary residence)',
                  'Income exceeding $200,000 in each of the two most recent years',
                  'Joint income with spouse exceeding $300,000',
                  'Holders of Series 7, 65, or 82 licenses in good standing'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-2 text-sm text-gray-300">
                    <span style={{ color: '#b8860b' }}>•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="p-6" style={{ background: '#1a2d4a', border: '1px solid rgba(184, 134, 11, 0.1)', borderRadius: '2px' }}>
              <h3 className="text-sm font-medium tracking-wider mb-4" style={{ color: '#b8860b' }}>ENTITY QUALIFICATIONS</h3>
              <ul className="space-y-3">
                {[
                  'Banks, insurance companies, registered investment companies',
                  'Employee benefit plans with assets exceeding $5,000,000',
                  'Corporations, partnerships, or LLCs with assets exceeding $5,000,000',
                  'Family offices with at least $5,000,000 in assets under management'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-2 text-sm text-gray-300">
                    <span style={{ color: '#b8860b' }}>•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 px-6" style={{ background: 'rgba(0,0,0,0.2)' }}>
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-xs tracking-widest mb-4" style={{ color: '#b8860b' }}>QUESTIONS?</p>
          <h2 className="text-2xl font-light text-white mb-4">Contact Compliance</h2>
          <p className="text-sm text-gray-400 mb-6">
            For questions regarding compliance, disclosures, or platform access requirements, 
            please contact our compliance team.
          </p>
          <p className="text-sm" style={{ color: '#b8860b' }}>compliance@bethereum.com</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t py-12 px-6" style={{ borderColor: 'rgba(184, 134, 11, 0.1)' }}>
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #b8860b 0%, #8b6914 100%)' }}>
                <span className="text-[#0a1628] font-bold">B</span>
              </div>
              <span className="text-white text-sm tracking-wide">BETHEREUM</span>
            </div>
            <div className="flex items-center gap-6">
              <Link to="/terms" className="text-xs" style={{ color: '#6c757d' }}>Terms</Link>
              <Link to="/privacy" className="text-xs" style={{ color: '#6c757d' }}>Privacy</Link>
              <Link to="/" className="text-xs" style={{ color: '#6c757d' }}>Home</Link>
            </div>
          </div>
          <div className="pt-8 border-t text-center" style={{ borderColor: 'rgba(255,255,255,0.05)' }}>
            <p className="text-xs" style={{ color: '#6c757d' }}>
              © 2026 Bethereum. All rights reserved. BETH tokens are utility tokens for platform use only 
              and are not offered as securities or investment products.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Compliance;
